// App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/dashboard/dashboard';
import SignInForm from './pages/signin/signin';
import SignUpForm from './pages/signup/signup';
import { GlobalProvider } from './store/GlobalContext';
import AuthGuard from './authguard';
import ResetPasswordPage from './pages/resetpassword/resetpassword';
import AcceptInvite from './pages/verify/acceptinvite';
import ActivateAccount from './pages/verify/activateaccount';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const client = new QueryClient();

// Token refresh is handled in one place only: the axios response interceptor
// in services/api.ts. Running a second periodic refresher here raced with the
// interceptor — the backend blacklists each used refresh token, so whichever
// refresh lost the race got a 401 and force-logged the user out.

function App() {
  return (
    <GlobalProvider>
      <QueryClientProvider client={client}>
        <Router>
          <Routes>
            <Route path="/login" element={<SignInForm />} />
            <Route path="/signup" element={<SignUpForm />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/user/invite/:token" element={<AcceptInvite />} />
            <Route path="/activate" element={<ActivateAccount />} />
            <Route element={<AuthGuard />}>
              <Route path="/*" element={<Dashboard />} />
            </Route>
          </Routes>
        </Router>
      </QueryClientProvider>
    </GlobalProvider>
  );
}

export default App;
